import {Modal} from "flowbite-react";
import {HiOutlineExclamation} from "react-icons/hi";
import CustomButton from "../../../components/common/CustomButton";
import React from "react";

interface CreateTaskWarningModalProps {
  showCreateTaskWarningModal: boolean;
  setShowCreateTaskWarningModal: (showCreateTaskWarningModal: boolean) => void;
  onCreateTaskConfirm: () => void;
}

const CreateTaskWarningModal: React.FC<CreateTaskWarningModalProps> = ({showCreateTaskWarningModal, setShowCreateTaskWarningModal, onCreateTaskConfirm}) => {

  return (
    <Modal show={showCreateTaskWarningModal} onClose={() => setShowCreateTaskWarningModal(false)} className="h-[100vh] z-[9999]">
      <Modal.Header></Modal.Header>
      <Modal.Body>
        <div className="space-y-6">
          <div className="items-center text-center flex flex-col justify-center dark:text-white text-gray-600 text-base font-normal font-['Inter'] leading-snug">
            <HiOutlineExclamation className="text-6xl" /><br/>
            Hey there,<br/>
            Looks like You are making changes<br/>
            in live version,<br/>
            please select a simulation mode to change
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="items-center flex justify-center">
        <CustomButton className="bg-primary-light dark:bg-primary-dark hover:bg-primary-dark text-white" onClick={onCreateTaskConfirm}>Ok</CustomButton>
      </Modal.Footer>
    </Modal>
  );
}

export default CreateTaskWarningModal;